import state from './moduleProfileState';
import mutations from './moduleProfileMutations';
import actions from './moduleProfileActions';
import getters from './moduleProfileGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
